/**
 * Offering API facade — currently backed by in-memory dummy store.
 *
 * TODO: replace with live endpoints once BE contract is ready:
 *   GET  {crudeHost}/v1/Offering?page&pageSize&searchText&sortField&sortOrder
 *   GET  {crudeHost}/v1/Offering/{id}
 *
 * Rejection shape intentionally matches crude_api_helper.js: plain string.
 */
import * as store from './offeringStore';

const LATENCY_MS = 150;

const settle = producer =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(producer());
      } catch (err) {
        reject(err instanceof Error ? err.message : String(err));
      }
    }, LATENCY_MS);
  });

/**
 * @param {{ page?: number, pageSize?: number, searchText?: string, sortField?: string, sortOrder?: string }} params
 * @returns {Promise<{ items: object[], totalCount: number }>}
 */
export const listOfferings = ({
  page = 1,
  pageSize = 10,
  searchText = '',
  sortField = null,
  sortOrder = 'asc',
} = {}) =>
  settle(() =>
    store.list({
      search: searchText,
      page,
      pageSize,
      sortField,
      sortDir: sortOrder,
    })
  );

/**
 * @param {string} id
 * @returns {Promise<object>}
 */
export const getOffering = id =>
  settle(() => {
    const rec = store.getById(id);
    if (!rec) throw new Error('Offering not found');
    return rec;
  });

/**
 * @param {string} id
 * @param {object} payload
 * @returns {Promise<object>}
 */
export const saveOfferingDraft = (id, payload) =>
  settle(() => store.saveDraft(id, payload));

/**
 * @param {string} id
 * @param {object} payload
 * @returns {Promise<object>}
 */
export const submitOfferingOffer = (id, payload) =>
  settle(() => store.submitOffer(id, payload));
